import { BadgeColorList } from 'components'
import { LeadPriority, LEAD_TYPE } from 'utils/constants'

export type BaseBadgeProps = {
  color: BadgeColorList
  text: string
  value?: string | number | null
}

type LeadBadge = BaseBadgeProps & {
  icon: string | string[]
}

export enum DropdownBadgeType {
  leadPriority = 'leadPriority',
  leadType = 'leadType',
}

export const leadPriorityBadges: BaseBadgeProps[] = [
  {
    color: 'disabled',
    text: 'lead_priority_lowest_lbl',
    value: LeadPriority.lowest,
  },
  {
    color: 'gray',
    text: 'lead_priority_low_lbl',
    value: LeadPriority.low,
  },
  {
    color: 'orange',
    text: 'lead_priority_high_lbl',
    value: LeadPriority.high,
  },
  {
    color: 'red',
    text: 'lead_priority_highest_lbl',
    value: LeadPriority.highest,
  },
  {
    color: 'yellow',
    text: 'lead_priority_medium_lbl',
    value: LeadPriority.medium,
  },
  {
    color: 'disabled',
    text: 'unavailable',
    value: null,
  },
]

export const leadTypeBadges: BaseBadgeProps[] = [
  { color: 'purple', text: 'lead_type_corporate_lbl', value: LEAD_TYPE.corporate },
  { color: 'yellow', text: 'lead_type_individual_lbl', value: LEAD_TYPE.individual },
  {
    color: 'disabled',
    text: 'unavailable',
    value: null,
  },
]

export const dropdownBadges = {
  [DropdownBadgeType.leadPriority]: leadPriorityBadges,
  [DropdownBadgeType.leadType]: leadTypeBadges,
}

export const leadBadges: LeadBadge[] = [
  {
    color: 'green',
    icon: ['far', 'trophy-alt'],
    text: 'customer',
  },
  {
    color: 'gray',
    icon: ['far', 'pennant'],
    text: 'lead',
  },
  {
    color: 'orange',
    icon: ['far', 'bullseye-arrow'],
    text: 'prospect',
  },
]
